import { createSelector } from "reselect";
import get from "lodash/get";
import _ from "lodash";
import Session from "session";
import { convertCamelCase } from "utils/helpers";

const cisFormPartnersDomain = state =>
  get(state, "form.CisPartnersForm.values", {});

const cisFormFieldsDomain = state =>
  get(state, "api.cisPartner.data.partner.registration.fields", []);

const cisAPIResultDomain = state =>
  get(state, "api.cisPartner.data.partner", {});
/*
 ************** CIS Form Selectors ************
 */
export const cisPartnersSelector = createSelector(
  cisFormPartnersDomain,
  cisPartnersForm => cisPartnersForm
);

export const cisFormFieldSelector = createSelector(
  cisFormFieldsDomain,
  cisFormFields => cisFormFields
);

export const cisAPIResultSelector = createSelector(
  cisAPIResultDomain,
  cisAPIResult => cisAPIResult
);

/*
 ************** Make Selectors ************
 */
export const makeSelectCisPartnersForm = () => cisPartnersSelector;

export const makeSelectCisPartnersFormParams = () =>
  createSelector(
    cisPartnersSelector,
    cisAPIResultSelector,
    cisFormFieldSelector,
    (cisPartnersForm, cisAPIResult, cisFormFields) => {
      let formData = {
        campaignId: cisAPIResult.campaignId,
        partner: cisAPIResult.partner,
        redirectUrl: `/partners/${cisAPIResult.path}`,
        registration: { reset: "true" },
        session_id: Session.getDeviceId()
      };

      cisFormFields.map(field => {
        let paramName = field.key;
        const fieldData = get(cisPartnersForm, paramName, "");
        const obj = {};
        obj[paramName] = fieldData;
        _.assign(formData, obj);

        if (paramName === "firstName" || paramName === "lastName") {
          paramName = convertCamelCase(paramName);
          obj[paramName] = fieldData;
          _.assign(formData, obj);
        }

        return obj;
      });

      return formData;
    }
  );

export const makeSelectPartnerFormFields = () =>
  createSelector(cisFormFieldSelector, cisFormFields => {
    let fields = cisFormFields.map(field => {
      switch (field.type) {
        case "email":
          return {
            ...field,
            name: "TEXT_FIELD",
            field: field.key,
            label: field.title,
            placeholder: field.hint,
            required: true
          };
        case "text":
          return {
            ...field,
            name: "TEXT_FIELD",
            field: field.key,
            label: field.title,
            required: true
          };
        default:
          return {};
      }
    });
    return fields;
  });
